import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DateInputControl, Form, FormSubmit, TextInputControl } from '@/core/components';

import { LegalHolidaySchema } from './model/LegalHolidaySchema';

interface LegalHolidayFormProps extends FormSubmit<LegalHolidaySchema> {
  title: string;
  onClose: () => void;
}

export function LegalHolidayForm(props: LegalHolidayFormProps) {
  const { title, onClose, schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();

  const form = useForm<LegalHolidaySchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <Modal
      opened
      centered
      onClose={onClose}
      title={title}
    >
      <FormProvider {...form}>
        <Form
          onSubmit={form.handleSubmit(onSubmit)}
          onCancel={onCancel}
          isSubmitting={isSubmitting}
        >
          <DateInputControl
            name="date"
            label={t('legalHolidays.form.fields.date')}
            isSubmitting={isSubmitting}
            withAsterisk
            control={form.control}
          />
          <TextInputControl
            name="name"
            label={t('legalHolidays.form.fields.name')}
            isSubmitting={isSubmitting}
            withAsterisk
            control={form.control}
          />
        </Form>
      </FormProvider>
    </Modal>
  );
}
